<script>
import LeadAds from './components/LeadAds.vue';
import PixelsCapi from './components/PixelsCapi.vue';
import Publicos from './components/Publicos.vue';
import LeadForms from './components/LeadForms.vue';
import Conversoes from './components/Conversoes.vue';
import GooglePublicos from './components/GooglePublicos.vue';
import GA4 from './components/GA4.vue';
import Conexoes from './components/Conexoes.vue';
import CustosManuais from './components/CustosManuais.vue';
import AliasCampanhas from './components/AliasCampanhas.vue';
import TiktokPixels from './components/TiktokPixels.vue';
import TiktokLeadAds from './components/TiktokLeadAds.vue';
import TiktokPublicos from './components/TiktokPublicos.vue';
import ComingSoon from './components/ComingSoon.vue';
import MobileSectionChips from 'dashboard/components-next/MobileSectionChips.vue';

export default {
  components: {
    MobileSectionChips,
    LeadAds,
    PixelsCapi,
    Publicos,
    LeadForms,
    Conversoes,
    GooglePublicos,
    GA4,
    Conexoes,
    CustosManuais,
    AliasCampanhas,
    TiktokPixels,
    TiktokLeadAds,
    TiktokPublicos,
    ComingSoon,
  },
  data() {
    return {
      selected: 'connections',
    };
  },
  computed: {
    sections() {
      return [
        {
          label: this.$t('META_ADS.NAV.SETUP'),
          items: [
            {
              key: 'connections',
              label: this.$t('META_ADS.NAV.CONNECTIONS'),
              icon: 'i-lucide-plug',
              active: true,
            },
          ],
        },
        {
          label: this.$t('META_ADS.NAV.META'),
          items: [
            {
              key: 'meta.leadAds',
              label: this.$t('META_ADS.NAV.LEAD_ADS'),
              icon: 'i-lucide-magnet',
              active: true,
            },
            {
              key: 'meta.capi',
              label: this.$t('META_ADS.NAV.PIXELS_CAPI'),
              icon: 'i-lucide-activity',
              active: true,
            },
            {
              key: 'meta.audiences',
              label: this.$t('META_ADS.NAV.AUDIENCES'),
              icon: 'i-lucide-users',
              active: true,
            },
          ],
        },
        {
          label: this.$t('META_ADS.NAV.GOOGLE'),
          items: [
            {
              key: 'google.leadForms',
              label: this.$t('META_ADS.NAV.LEAD_FORMS'),
              icon: 'i-lucide-file-text',
              active: true,
            },
            {
              key: 'google.conversions',
              label: this.$t('META_ADS.NAV.CONVERSIONS'),
              icon: 'i-lucide-target',
              active: true,
            },
            {
              key: 'google.audiences',
              label: this.$t('META_ADS.NAV.AUDIENCES'),
              icon: 'i-lucide-users',
              active: true,
            },
            {
              key: 'google.ga4',
              label: this.$t('META_ADS.NAV.GA4'),
              icon: 'i-lucide-line-chart',
              active: true,
            },
          ],
        },
        {
          label: this.$t('META_ADS.NAV.TIKTOK'),
          items: [
            {
              key: 'tiktok.leadAds',
              label: this.$t('META_ADS.NAV.LEAD_ADS'),
              icon: 'i-lucide-magnet',
              active: true,
            },
            {
              key: 'tiktok.pixels',
              label: this.$t('META_ADS.NAV.TIKTOK_PIXELS'),
              icon: 'i-lucide-activity',
              active: true,
            },
            {
              key: 'tiktok.audiences',
              label: this.$t('META_ADS.NAV.AUDIENCES'),
              icon: 'i-lucide-users',
              active: true,
            },
          ],
        },
        {
          label: this.$t('META_ADS.NAV.COSTS'),
          items: [
            {
              key: 'costs',
              label: this.$t('META_ADS.NAV.MANUAL_COSTS'),
              icon: 'i-lucide-receipt',
              active: true,
            },
            {
              key: 'aliases',
              label: this.$t('META_ADS.NAV.CAMPAIGN_ALIASES'),
              icon: 'i-lucide-link',
              active: true,
            },
          ],
        },
      ];
    },
    selectedItem() {
      return this.sections
        .flatMap(section => section.items)
        .find(item => item.key === this.selected);
    },
  },
  watch: {
    '$route.query.tab'(tab) {
      this.applyTabFromQuery(tab);
    },
  },
  mounted() {
    this.applyTabFromQuery(this.$route.query.tab);
  },
  methods: {
    select(item) {
      if (!item.active) return;
      this.selected = item.key;
      if (this.$route.query.tab !== item.key) {
        this.$router.replace({
          query: { ...this.$route.query, tab: item.key },
        });
      }
    },
    applyTabFromQuery(tab) {
      if (!tab) return;
      const exists = this.sections
        .flatMap(section => section.items)
        .some(item => item.key === tab && item.active);
      if (exists) this.selected = tab;
    },
  },
};
</script>

<template>
  <div
    class="flex flex-col md:flex-row w-full h-full min-h-0 -mx-6 -mb-6 sm:-mb-8 lg:-mx-16"
  >
    <!-- Mobile (F2): a nav lateral vira chips deslizaveis no topo -->
    <MobileSectionChips
      :sections="sections"
      :selected="selected"
      @select="select"
    />
    <nav
      class="hidden md:flex flex-col w-56 gap-4 p-4 overflow-y-auto border-r shrink-0 border-n-weak bg-n-surface-1"
    >
      <h2 class="px-2 text-sm font-semibold text-n-slate-12">
        {{ $t('META_ADS.HEADER') }}
      </h2>
      <div
        v-for="section in sections"
        :key="section.label"
        class="flex flex-col gap-0.5"
      >
        <p
          class="px-2 mb-1 text-xs font-medium tracking-wide uppercase text-n-slate-10"
        >
          {{ section.label }}
        </p>
        <button
          v-for="item in section.items"
          :key="item.key"
          type="button"
          :disabled="!item.active"
          class="flex items-center w-full gap-2 px-2 py-1.5 text-sm text-left rounded-lg"
          :class="[
            item.active
              ? 'cursor-pointer hover:bg-n-slate-3'
              : 'cursor-not-allowed opacity-50',
            selected === item.key
              ? 'bg-n-slate-3 text-n-slate-12 font-medium'
              : 'text-n-slate-11',
          ]"
          @click="select(item)"
        >
          <span :class="item.icon" class="text-base" />
          <span class="flex-1">{{ item.label }}</span>
          <span
            v-if="!item.active"
            class="text-[10px] px-1.5 py-0.5 rounded-full bg-n-slate-3 text-n-slate-10"
          >
            {{ $t('META_ADS.SOON_BADGE') }}
          </span>
        </button>
      </div>
    </nav>

    <div class="flex-1 min-w-0 px-6 py-6 overflow-y-auto">
      <Conexoes v-if="selected === 'connections'" />
      <LeadAds v-else-if="selected === 'meta.leadAds'" />
      <PixelsCapi v-else-if="selected === 'meta.capi'" />
      <Publicos v-else-if="selected === 'meta.audiences'" />
      <LeadForms v-else-if="selected === 'google.leadForms'" />
      <Conversoes v-else-if="selected === 'google.conversions'" />
      <GooglePublicos v-else-if="selected === 'google.audiences'" />
      <GA4 v-else-if="selected === 'google.ga4'" />
      <CustosManuais v-else-if="selected === 'costs'" />
      <AliasCampanhas v-else-if="selected === 'aliases'" />
      <TiktokLeadAds v-else-if="selected === 'tiktok.leadAds'" />
      <TiktokPixels v-else-if="selected === 'tiktok.pixels'" />
      <TiktokPublicos v-else-if="selected === 'tiktok.audiences'" />
      <ComingSoon v-else :title="selectedItem ? selectedItem.label : ''" />
    </div>
  </div>
</template>
